import { Lock, ShieldCheck, CreditCard, Stethoscope, Cookie } from "lucide-react";

/**
 * Trust-badge row — used in the footer, checkout-success and below the
 * landing-page hero. Generic-but-solid; matches Feel Greats green / amber.
 */
const BADGES = [
  { icon: Lock, label: "SSL Secure", sub: "256-bit encryption" },
  { icon: CreditCard, label: "Stripe Secured", sub: "Industry-standard payments" },
  { icon: Cookie, label: "GDPR · Privacy", sub: "EU data-protection compliant" },
  { icon: ShieldCheck, label: "Secure Checkout", sub: "Your card never touches our server" },
  { icon: Stethoscope, label: "Wellness Guidance", sub: "Not a medical diagnosis" },
];

export default function TrustBadgeRow({ compact = false, className = "" }) {
  return (
    <div
      className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2 sm:gap-3 ${className}`}
      data-testid="trust-badge-row"
      aria-label="Site trust and security badges"
    >
      {BADGES.map((b) => (
        <div
          key={b.label}
          className="flex items-center gap-2 sm:gap-3 px-3 py-2.5 rounded-xl border border-emerald-100/80 bg-white/70 backdrop-blur-sm"
          data-testid={`trust-badge-${b.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        >
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-emerald-50 text-emerald-700 shrink-0">
            <b.icon className="w-4 h-4" />
          </span>
          <div className="leading-tight min-w-0">
            <div className="text-[12px] sm:text-[13px] font-medium text-emerald-950 truncate">{b.label}</div>
            {!compact ? (
              <div className="text-[10px] sm:text-[11px] text-emerald-900/60 truncate">{b.sub}</div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
}
